import { render } from "./IconAutoDirection.vue?vue&type=template&id=1273aed3&scoped=true"
import script from "./IconAutoDirection.vue?vue&type=script&lang=js"
export * from "./IconAutoDirection.vue?vue&type=script&lang=js"

import "./IconAutoDirection.vue?vue&type=style&index=0&id=1273aed3&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1273aed3"]])

export default __exports__